module.exports = __webpack_public_path__ + "media/components/Lottery/Tickets/claimed-33cd994d673528f00e9a9956a9eb8dde.svg";